"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNodeList = toNodeList;
function toNodeList(arrayOfNodes) {
    var fragment = document.createDocumentFragment();
    arrayOfNodes.forEach(function (item) {
        fragment.appendChild(item.cloneNode(true));
    });
    return fragment.childNodes;
}
